import useReferredCreate from "./Create";

const useReferred = () => {
  return {
    useReferredCreate
  };
};

export default useReferred;
